module.exports = __webpack_public_path__ + "img/icon20.d6350d6a.d6350d6a.svg";